// extracted by mini-css-extract-plugin
export default {"search-loader":"search-loader--1JIEu"};